import { ServicePage } from './ServicePage';
import { Monitor } from 'lucide-react';

const PlatformPage = () => {
  return <ServicePage serviceKey="platform" icon={Monitor} />;
};

export default PlatformPage;
